import { SITE_URL, SITE_NAME } from '../../utils/seoConstants';

export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": SITE_NAME,
    "url": SITE_URL,
    "logo": `${SITE_URL}/imgi_1_favicon.png`,
    "description": "Connect with expert tutors worldwide for personalized one-on-one tutoring sessions in mathematics, science, languages, coding, and more.",
    "sameAs": [
      "https://www.facebook.com/worldotutor",
      "https://www.instagram.com/worldotutor",
      "https://www.linkedin.com/company/worldotutor",
      "https://twitter.com/worldotutor"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-7814688725",
      "contactType": "customer service",
      "availableLanguage": ["English", "Hindi"],
      "areaServed": "Worldwide"
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IN"
    }
  };

  return (
    <script
      key="organization-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default OrganizationSchema;
